import { createSlice } from "@reduxjs/toolkit";

const initialState =  {
    submitCheck: {}
};

const submitCheckSlice = createSlice({
    name: "submit check",
    initialState,
    reducers: {
        setSubmitCheck: (state, action) => {
            state.submitCheck= action.payload;
        }
    },
});

export const { setSubmitCheck } =
    submitCheckSlice.actions;
export default submitCheckSlice.reducer;